import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { browserHistory, withRouter } from 'react-router'
import set from 'lodash/set'

import Collapsible from '../../util/Collapsible'
import OrderStore from '../../../stores/orders'
import Provision from '../../../stores/provision'
import MlsStore from '../../../stores/mls'
import MlsAutocomplete from '../../util/auto_complete/MlsAutocomplete'

import RailsError from '../../util/RailsError'
import Icon from '../../util/Icon'

@withRouter
@observer
export default class OrderDetails extends Component {
  order = new OrderStore()
  mlsStore = new MlsStore()
  provisionStore = new Provision()

  state = {
    errors: null,
    selectedMLS: {},
    selectedMLSs: [],
    errorsv2: null
  }

  componentWillMount() {
    const { params: { order_id } } = this.props

    this.order.load(order_id)
    this.mlsStore.loadMlsInfo(true)
  }

  cancelOrder = event => {
    event.preventDefault()
    this.order.delete(this.props.params.order_id).then(() => {
      alert("Order deleted successfully.")
      browserHistory.push('/orders')
    })
  }

  handleSubmit = event => {
    event.preventDefault()

    this.setState({ errors: null })
    event.preventDefault()

    const { params: { order_id } } = this.props
    const order = this.order.findById(order_id)

    let missingRequiredFields = false

    const mls = [...event.target.elements].reduce((serial, next) => {
      if (next.required && !next.value) {
        next.style.border = '1px solid red'
        missingRequiredFields = true
      }
      if (next.name) set(serial, next.name, next.value)
      return serial
    }, {})

    const data = { ...order.params, mls, order_id }

    if (!missingRequiredFields) {
      this.provisionStore.create(data).then(resp => {
        this.props.router.push(`/teams/${resp.team.id}`)
      }).catch(error => this.setState({ errors: error.response.data }))
    }
    
  }

  handleSubmitv2 = (event) => {
    event.preventDefault()

    this.setState({ errorsv2: null })
    event.preventDefault()

    const {
      params: { order_id },
    } = this.props
    const order = this.order.findById(order_id)

    let missingRequiredFields = false

    const mls = [...event.target.elements].reduce((serial, next) => {
      if (next.required && !next.value) {
        next.style.border = "1px solid red"
        missingRequiredFields = true
      }
      if (next.name) set(serial, next.name, next.value)
      return serial
    }, {})
    let data = {}
    if (order.params.user_type === "dev_with_agent") {
      const {
        agent_email,
        agent_first_name,
        agent_last_name,
        agent_phone,
        ...filteredMls
      } = mls
      data = {
        ...order.params,
        mls: filteredMls,
        order_id,
        agent_email,
        agent_first_name,
        agent_last_name,
        agent_phone,
      }
    } else {
      data = { ...order.params, mls, order_id }
    }
    if (!missingRequiredFields) {
      this.provisionStore
        .create(data)
        .then((resp) => {
          this.props.router.push(`/teams/${resp.team.id}`)
        })
        .catch((error) => this.setState({ errorsv2: error.response.data }))
    }
  };

  renderMlsInfoFormItem = ({ name, mls_id }) => (
    <div key={mls_id}>
      <strong>{name} - {mls_id.toUpperCase()}</strong>

      <div className="side-by-side">
        <input type="text" name={`[${mls_id}]agent_id`} placeholder="MLS Agent ID" required />
        <input type="text" name={`[${mls_id}]office_id`} placeholder="MLS Office ID" required />
      </div>

      <div className="side-by-side">
        <input type="text" name={`[${mls_id}]broker_first_name`} placeholder="Managing Broker First Name" required />
        <input type="text" name={`[${mls_id}]broker_last_name`} placeholder="Managing Broker Last Name" required />
      </div>
      <input type="email" name={`[${mls_id}]broker_email`} placeholder="Managing Broker Email" required />
      <br />
    </div>
  )

  renderMlsInfoForm(order) {
    if (order.status !== 'pending' || !order.params.mls_selected || order.params.user_type) {
      return
    }
    const active = order.params.mls_selected.filter(mls => mls.active)
    if (!order.params.mls && active.length) {
      return (
        <form className="mls-info-form" onSubmit={this.handleSubmit}>
          <h3>Needs MLS Info</h3>
          {active.map(this.renderMlsInfoFormItem)}
          <button>Complete Account</button>
          {this.state.errors && <RailsError errors={this.state.errors} />}
        </form>
      )
    }
  }

  renderNotify(order) {
    if (!order.params.mls_selected) {
      return
    }
    const inactive = order.params.mls_selected.filter(mls => !mls.active)
    if (inactive.length) {
      return (
        <div>
          <h3>Notify When These MLSs are Available:</h3>
          <ul>
            {inactive.map(mls => (
              <li key={mls.mls_id}>
                <strong>{mls.mls_id.toUpperCase()}</strong> <em>{mls.name}</em>
              </li>
            ))}
          </ul>
        </div>
      )
    }
  }

  handleSelectMls = (mls) => {
    if (!mls) {
      this.setState({ selectedMLS: {} })
      return
    }
    const { selectedMLSs } = this.state
    if (selectedMLSs.includes(mls)) {
      return
    }
    this.setState({
      selectedMLSs: [...this.state.selectedMLSs, mls],
      selectedMLS: {},
    })
  }

  deleteMLS = (mls_id) => {
    this.setState((prevState) => ({
      selectedMLSs: prevState.selectedMLSs.filter((mls) => mls.mls_id !== mls_id),
    }))
  };

  renderMlsInfoFormItemV2 = ({ name, mls_id, deleteMLS }) => (
    <div key={mls_id}>
      <div>
        <strong>{name} - {mls_id.toUpperCase()}</strong>
        <div style={{ float: 'right' }}><Icon icon="times" onClick={()=> deleteMLS(mls_id)} /></div>
      </div>
      <div className="side-by-side">
        <input type="text" name={`[${mls_id}]broker_first_name`} placeholder="Managing Broker First Name"  />
        <input type="text" name={`[${mls_id}]broker_last_name`} placeholder="Managing Broker Last Name"  />
      </div>
      <input type="email" name={`[${mls_id}]broker_email`} placeholder="Managing Broker Email"  />
      <br />
    </div>
  )

  render() {
    const { params: { order_id } } = this.props

    window.order = this.order
    window.order_id = order_id

    if (!this.order.loaded) return <div className="loading">Loading...</div>

    const order = this.order.findById(order_id)
    if (!order) return null

    return (
      <div className="container padded order">
        <div className="container">
          <div className="panel full padded">
            <h2 className="title">
              Order For: {order.params.agent_first_name} {order.params.agent_last_name}
            </h2>

            <div className="container">
              <div className="half">
                <ul>
                  <li><strong>Status:</strong> <span>{order.status}</span></li>
                </ul>
                <form><button name="delete_order" hidden={order.status === 'complete'} onClick={this.cancelOrder}>Delete Pending Order</button></form>

              </div>
              <div className="half">
                <Collapsible triggerClassName="order button" triggerOpenedClassName="order button" trigger="Raw Order Details">
                  <pre>{JSON.stringify(order, null, 2)}</pre>
                </Collapsible>
              </div>
              <br />
              <br />
            </div>

            <div className="container">
              {this.renderMlsInfoForm(order)}
            </div>

            <div className="container">
              {this.renderNotify(order)}
            </div>

           {order.status == 'pending' && order.params.user_type &&
           <div>
            <div className="container">
              <div className="group">
                  <label className="left-label">Select an MLS: </label>
                  <MlsAutocomplete mlsStore={this.mlsStore} onSelect={this.handleSelectMls} />
              </div>
            </div>

            {this.state.selectedMLSs.length>0 && (
              <div className="container">
                <form className="mls-info-form" onSubmit={this.handleSubmitv2}>
                  <h3>Needs MLS Info</h3>
                  {this.state.selectedMLSs.map((mls) =>
                    this.renderMlsInfoFormItemV2({
                      ...mls,
                      deleteMLS: this.deleteMLS, 
                    })
                  )}
                  {order.params.user_type == "dev_with_agent" && !order.params.agent_email && <div>
                    <h3>Needs Agent Info</h3>
                    <div className="side-by-side">
                      <input type="text" name={`agent_first_name`} placeholder="Agent First Name" required />
                      <input type="text" name={`agent_last_name`} placeholder="Agent Last Name" required />
                      
                    </div>
                    <div className="side-by-side">
                    <input type="tel" name="agent_phone" placeholder={`Agent's Phone`} required />
                      <input type="email" name={`agent_email`} placeholder="Agent Email" required />
                      </div>
                  </div>}
                  <button>Complete Account</button>
                  {this.state.errorsv2 && (
                    <RailsError errors={this.state.errorsv2} />
                  )}
                </form>
              </div>
            )}
             </div>
            }
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/Orders/Details.js